import React from 'react';
import { motion } from 'framer-motion';
export function TeamShowcase() {
  return <section className="py-14 md:py-20 bg-white overflow-hidden" data-id="element-274">
      <div className="container mx-auto px-4" data-id="element-275">
        <div className="text-center mb-10" data-id="element-276">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4 uppercase" data-id="element-277">
            Personas Reales. Compromiso Real.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-278">
            Nuestro equipo trabaja cada día para proteger a las familias de
            Tampa.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto" data-id="element-279">
          {/* Photo 2: Team Meeting */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col" data-id="element-280">
            <div className="rounded-2xl overflow-hidden shadow-lg border-b-4 border-gold" data-id="element-281">
              <img src="https://cdn.magicpatterns.com/uploads/qF6cvs7FHS4SUbqVc65fdP/FOTO_DE_ANGEL_115.jpg" alt="Equipo de Angel Insurance en acción" className="w-full h-[300px] md:h-[400px] object-cover object-center" data-id="element-282" />
            </div>
            <p className="text-center text-gray-600 mt-4 italic text-sm md:text-base" data-id="element-283">
              Nuestro equipo en acción — siempre aprendiendo para servirte mejor
            </p>
          </motion.div>

          {/* Photo 3: Kickoff Event */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="flex flex-col" data-id="element-284">
            <div className="rounded-2xl overflow-hidden shadow-lg border-b-4 border-gold" data-id="element-285">
              <img src="https://cdn.magicpatterns.com/uploads/mBidQZ9ZuDAqYi4E2EcvGV/FOTO_DE_ANGEL_113.jpg" alt="Kickoff 2026 de Angel Insurance" className="w-full h-[300px] md:h-[400px] object-cover object-top" data-id="element-286" />
            </div>
            <p className="text-center text-gray-600 mt-4 italic text-sm md:text-base" data-id="element-287">
              Kickoff 2026 — Celebrando otro año protegiendo familias en Tampa
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}